import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';

export const StyledPlaydogBundle = styled.div`
  box-sizing: border-box;
  font-family: ${(props: any) => props.fontFamily};
  width: 100%;
  max-width: 166px;
  min-width: 166px;
  height: 265px;
  position: relative;

  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  padding: 42px 8px 8px 8px;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 12px 0 rgba(255, 255, 255, 0.8) inset;
  border-radius: 8px;

  .playdog-bundle {
    &__emblem-badge {
      position: absolute;
      left: 0;
      top: 4px;
      background-image: url(${(props: any) => props.badgeImage});
      background-repeat: no-repeat;
      z-index: 1000;
      height: 32px;

      @media (width <= ${breakpoints.mobileM}) {
        top: 5px;
        height: 28px;
      }

      img {
        max-height: 100%;
      }
    }

    &-products {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      gap: 4px;
      justify-content: center;

      &__sub {
        height: 100%;
        gap: 4px;
        display: flex;
        flex-direction: column;
      }
    }
  }
` as any;

export const StyledEmblemBadge = styled.div`
  position: absolute;
  left: -8px;
  top: -8px;
  z-index: 1000;
  height: 54px;
  min-height: 54px;
  width: auto;

  img {
    height: 54px;
    min-height: 54px;
    width: 54px;
    object-fit: contain;
  }
` as any;

export const StyledMainProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  z-index: 1;

  .product-img {
    height: 64px;
    width: 64px;
    position: absolute;
    z-index: -1;
    left: 50%;
    transform: translateX(-50%);
    bottom: 24px;
    display: flex;
    justify-content: center;

    .image {
      position: absolute;
      height: 64px;
      width: auto;
    }
  }

  .content-container {
    width: 100%;
    height: 32px;
    background: rgba(49, 21, 132, 0.9);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    font-family: ${(props: any) => props.fontFamily};
    min-width: 0;
    background: rgba(49, 21, 132, 0.9);

    .stroked-container,
    .quantity-container {
      padding: 0 4px;
      min-width: 0;
      z-index: 1;
      width: 100%;
      text-align: center;
      justify-content: center;
    }

    .quantity-container {
      &__value {
        display: flex !important;
        justify-content: center;
        align-items: center;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        color: #fff;
        width: calc(100% + 20px);
        text-transform: uppercase;
      }
    }

    .stroked-container {
      &__value {
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: #fff;
        width: 100%;
        text-decoration: line-through;
        text-decoration-color: #f00;
      }
    }
  }
` as any;

export const StyledSubProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  border-radius: 4px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  background: #311584;

  .product-info {
    display: flex;
    align-items: center;
    padding-left: 4px;
    width: 100%;

    .product-img {
      min-width: 28px;
      max-height: 28px;
      display: flex;
      justify-content: center;
      position: relative;

      .image {
        height: 28px;
        width: 28px;
      }
    }

    .price-container {
      padding-left: 4px;
      padding-right: 4px;
      min-width: 0;
      width: 100%;

      .quantity-container {
        &__value {
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          color: #fff;
          width: 100%;
          text-transform: uppercase;
        }
      }
    }
  }
` as any;

export const StyledPriceButton = styled.div`
  margin-top: 8px;
  font-family: ${({ fontFamily }: any) => fontFamily};
  background: var(--button-bg-color);
  display: flex;
  direction: ltr;
  justify-content: center;
  align-items: center;
  color: var(--button-text-color);
  position: relative;
  border-radius: 4px;
  width: 100%;
  min-height: 31px;
  height: 31px;
  border-bottom: 1px solid #31d9f8;
  box-shadow: 0px -1px 4.3px 0px #14fd29 inset;

  .totalPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
    z-index: 10;
    white-space: nowrap;
    font-weight: 700;
    width: 100%;

    span,
    .final-price,
    .stroked {
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3),
        -0.5px 0.5px 0 rgb(0, 101, 43), 0.5px -0.5px 0 rgb(0, 101, 43),
        -0.5px -0.5px 0 rgb(0, 101, 43), 0.5px 0.5px 0 rgb(0, 101, 43);
    }

    .stroked {
      font-size: calc(clamp(4px, 1em * 0.75, 12px));
    }
  }
` as any;
